import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const ErrorPage = ({ code, title, message }) => {
  return (
    <div className="container error-page">
      <h1 className="error-page__code">{code}</h1>
      <h2 className="error-page__title">{title}</h2>
      <p>{message}</p>
      <Link to="/" className="btn btn-primary error-page__home-link">
        Return Home
      </Link>
    </div>
  );
};

ErrorPage.propTypes = {
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default ErrorPage;
